<template>
  <div>
    <header class="p-2 d-flex align-items-center" style="background: transparent; box-shadow: none;">
      <div class="rounded-circle bg-teal-500" style="width: 2rem; height: 2rem;"></div>
    </header>
  </div>
</template>


<script>
  import { es } from 'date-fns/locale';

    export default {
        name: 'headerComponent',
        data() {
            return {
            esLocale: es,  // Calendario en español
                cotizar: {
                    fecha: null,  // Almacena el rango de fechas seleccionado
                },
            };
        },
        methods: {},
    };
</script>